import { Navigate, Outlet } from 'react-router';

import { FullPageSpinner } from '@/components/common/LoadingState';
import { useAuth } from '@/features/auth/useAuth';

import { paths } from './paths';

/** Keeps a signed-in user off the sign-in and password-reset screens. */
export function GuestRoute() {
  const { status } = useAuth();

  if (status === 'loading') {
    return <FullPageSpinner label="Checking your session…" />;
  }

  if (status === 'authenticated') {
    return <Navigate to={paths.dashboard} replace />;
  }

  return <Outlet />;
}
